import { useQueryComparables } from "./useQueryComparables";

export default {
  useQueryComparables,
};
